import PropTypes from "prop-types";

const UpgradeBundleGroupShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  mode: PropTypes.string
});

export default UpgradeBundleGroupShape;
